// menu js
document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector(".header__icon--menu");
  const menu = document.getElementById("menu");
  const purClass = document.querySelector(".pur-class");

  menuButton.addEventListener("click", function () {
    menu.classList.toggle("active");
    document.body.classList.toggle("menu-open");

    // Change button text
    if (menu.classList.contains("active")) {
      menuButton.textContent = "FERMER";
    } else {
      menuButton.textContent = "MENU";
    }
  });

  // Close menu when clicking on .pur-class
  if (purClass) {
    purClass.addEventListener("click", function () {
      menu.classList.remove("active");
      document.body.classList.remove("menu-open");
      menuButton.textContent = "MENU";
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("menu");
  const menuButton = document.querySelector(".header__icon--menu");
  const header = document.querySelector(".site-header"); // adjust selector if different

  document.querySelectorAll('a[href^="/#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").split("#")[1];

      if (window.location.pathname === "/" || window.location.pathname === "/index") {
        // Already on homepage → smooth scroll with offset
        e.preventDefault();
        const targetEl = document.getElementById(targetId);
        if (targetEl) {
          const headerHeight = header ? header.offsetHeight : 0;
          const elementPosition = targetEl.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      }
      // else → browser will redirect to homepage#id normally

      // ✅ Always close menu if open
      if (menu && menu.classList.contains("active")) {
        menu.classList.remove("active");
        document.body.classList.remove("menu-open");
        if (menuButton) {
          menuButton.textContent = "MENU";
        }
      }
    });
  });
});




// Testimonial Slider
 $(".talking-slider").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="19" viewBox="0 0 50 19" fill="currentcolor"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0102 18.404C9.98583 18.4628 9.9501 18.5162 9.90507 18.5612C9.86008 18.6063 9.80666 18.642 9.74786 18.6664C9.68906 18.6907 9.62603 18.7033 9.56237 18.7033C9.49872 18.7033 9.43569 18.6907 9.37689 18.6664C9.31808 18.642 9.26466 18.6063 9.21968 18.5612L0.500931 9.84247C0.455898 9.79749 0.42017 9.74407 0.395794 9.68527C0.371418 9.62646 0.358871 9.56343 0.358871 9.49978C0.358871 9.43612 0.371418 9.37309 0.395794 9.31429C0.42017 9.25549 0.455898 9.20207 0.500931 9.15708L9.21968 0.438335C9.26468 0.393332 9.31811 0.357633 9.37691 0.333277C9.43571 0.308922 9.49873 0.296387 9.56237 0.296387C9.62602 0.296387 9.68904 0.308922 9.74784 0.333277C9.80664 0.357633 9.86007 0.393332 9.90507 0.438335C9.95007 0.483338 9.98577 0.536765 10.0101 0.595565C10.0345 0.654365 10.047 0.717386 10.047 0.78103C10.047 0.844675 10.0345 0.907696 10.0101 0.966496C9.98577 1.0253 9.95007 1.07872 9.90507 1.12373L2.01339 9.0154L20 9.0154V9H50V10H20V9.98415L2.01339 9.98415L9.90507 17.8758C9.9501 17.9208 9.98583 17.9742 10.0102 18.033C10.0346 18.0918 10.0471 18.1549 10.0471 18.2185C10.0471 18.2822 10.0346 18.3452 10.0102 18.404Z"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="19" viewBox="0 0 50 19" fill="currentcolor"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.9898 18.404C40.0142 18.4628 40.0499 18.5162 40.0949 18.5612C40.1399 18.6063 40.1933 18.642 40.2521 18.6664C40.3109 18.6907 40.374 18.7033 40.4376 18.7033C40.5013 18.7033 40.5643 18.6907 40.6231 18.6664C40.6819 18.642 40.7353 18.6063 40.7803 18.5612L49.4991 9.84247C49.5441 9.79749 49.5798 9.74407 49.6042 9.68527C49.6286 9.62646 49.6411 9.56343 49.6411 9.49978C49.6411 9.43612 49.6286 9.37309 49.6042 9.31429C49.5798 9.25549 49.5441 9.20207 49.4991 9.15708L40.7803 0.438335C40.7353 0.393332 40.6819 0.357633 40.6231 0.333277C40.5643 0.308922 40.5013 0.296387 40.4376 0.296387C40.374 0.296387 40.311 0.308922 40.2522 0.333277C40.1934 0.357633 40.1399 0.393332 40.0949 0.438335C40.0499 0.483338 40.0142 0.536765 39.9899 0.595565C39.9655 0.654365 39.953 0.717386 39.953 0.78103C39.953 0.844675 39.9655 0.907696 39.9899 0.966496C40.0142 1.0253 40.0499 1.07872 40.0949 1.12373L47.9866 9.0154L30 9.0154V9H0V10H30V9.98415L47.9866 9.98415L40.0949 17.8758C40.0499 17.9208 40.0142 17.9742 39.9898 18.033C39.9654 18.0918 39.9529 18.1549 39.9529 18.2185C39.9529 18.2822 39.9654 18.3452 39.9898 18.404Z"></path></svg></button>'
  });


document.addEventListener("DOMContentLoaded", function () {
  const mensuel = document.querySelector(".section-featured-product-mensuel");
  const annuel = document.querySelector(".section-featured-product-annuel");

  if (mensuel && annuel) {
    // Create wrapper if it doesn't exist
    let wrapper = document.createElement("div");
    wrapper.classList.add("subscription-main");

    // Insert wrapper before mensuel
    mensuel.parentNode.insertBefore(wrapper, mensuel);

    // Move both sections into wrapper
    wrapper.appendChild(mensuel);
    wrapper.appendChild(annuel);
  }
});


  document.addEventListener('click', function (e) {
    if (e.target.matches('.custom-buy-now')) {
      e.preventDefault();

      const form = e.target.closest('form');
      const formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' })
        .then(() => {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData,
          });
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch((err) => console.error(err));
    }
  });

  // announcement
$(document).ready(function () {
  // Hide the bar when close icon is clicked
  $('#close-announcement').on('click', function () {
    $('.announcement-bar-section').slideUp();
    localStorage.setItem('announcementClosed', 'true');
  });

  // Keep it hidden if already closed before
  if (localStorage.getItem('announcementClosed') === 'true') {
    $('.announcement-bar-section').hide();
  }
});


// filter js 
document.addEventListener('DOMContentLoaded', function() {
  const heading = document.querySelector('.facets__heading');
  const wrapper = document.querySelector('#FacetsWrapperDesktop');

  if (heading && wrapper) {
    heading.addEventListener('click', function() {
      wrapper.classList.toggle('active');
      heading.classList.toggle('active');
    });
  }
});

